import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IFormGroup } from '@shared-libs/interfaces';
import { SharedFormValidators } from '@shared-libs/form-validators';
import { AddressFormFactory } from '@shared-factories/forms/address-form.factory';
import { ILocation } from '@internal-models/location.model';

export class LocationFormFactory {
	public static create(location?: ILocation): IFormGroup<ILocation> {
		return new FormGroup({
			id: new FormControl(location?.id),
			place: new FormControl(location?.place, [SharedFormValidators.required, SharedFormValidators.strictString]),
			comment: new FormControl(location?.comment, [Validators.maxLength(4096)]),
			Address: AddressFormFactory.createAsRequired(location?.Address),
		}) as IFormGroup;
	}
}
